export const DEFAULT_LANG = 'ru'
